<lib-modal
  [visible]="visible()"
  [title]="
    (istBearbeiten() ? 'projectForm.releases.dialog.titelBearbeiten' : 'projectForm.releases.dialog.titelAnlegen')
      | translate
  "
  [contentTemplate]="inhalt"
  [showButtons]="false"
  [showClose]="false"
  (visibleChange)="beimSchliessenDurchModal($event)"
></lib-modal>

<ng-template #inhalt>
  <div class="release-dialog" [formGroup]="form" data-testid="release-dialog">
    <mat-form-field appearance="fill" floatLabel="always" class="release-dialog__feld tc-field--uppercase-label">
      <mat-label>{{ 'projectForm.releases.dialog.id' | translate }}</mat-label>
      <input
        matInput
        formControlName="id"
        class="release-dialog__id"
        data-testid="release-id"
        required
        [readonly]="istBearbeiten()"
        [attr.maxlength]="idMax"
        (keydown.enter)="beiEingabetaste($event)"
      />
      @if (form.controls.id.hasError('idVergeben')) {
        <mat-error>{{ 'projectForm.releases.dialog.fehler.idVergeben' | translate }}</mat-error>
      } @else if (form.controls.id.hasError('idUngueltig')) {
        <mat-error>{{ 'projectForm.releases.dialog.fehler.idUngueltig' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="release-dialog__feld tc-field--uppercase-label">
      <mat-label>{{ 'projectForm.releases.dialog.name' | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        data-testid="release-name"
        [attr.maxlength]="nameMax"
        [placeholder]="
          platzhalterId() ? ('projectForm.releases.dialog.namePlatzhalter' | translate: { id: platzhalterId() }) : ''
        "
        (keydown.enter)="beiEingabetaste($event)"
      />
      @if (form.controls.name.hasError('nameUngueltig')) {
        <mat-error>{{ 'projectForm.releases.dialog.fehler.nameUngueltig' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="release-dialog__feld tc-field--uppercase-label">
      <mat-label>{{ 'projectForm.releases.dialog.stichtag' | translate }}</mat-label>
      <input
        matInput
        formControlName="stichtag"
        data-testid="release-stichtag"
        [required]="!istBearbeiten()"
        [matDatepicker]="stichtagPicker"
        [errorStateMatcher]="sofortFehler"
        (keydown.enter)="beiEingabetaste($event)"
      />
      <mat-datepicker-toggle matIconSuffix [for]="stichtagPicker" />
      <mat-datepicker #stichtagPicker />
      @if (form.controls.stichtag.hasError('matDatepickerParse')) {
        <mat-error>{{ 'common.errors.invalidDate' | translate }}</mat-error>
      } @else if (form.controls.stichtag.hasError('stichtagEntfernen')) {
        <mat-error>{{ 'projectForm.releases.dialog.fehler.stichtagEntfernen' | translate }}</mat-error>
      } @else if (form.controls.stichtag.hasError('goLivePflicht')) {
        <mat-error>{{ 'projectForm.releases.dialog.fehler.goLivePflicht' | translate }}</mat-error>
      }
    </mat-form-field>

    @if (dialogFehler(); as fehler) {
      <p class="release-dialog__fehler" role="alert" data-testid="release-dialog-fehler">
        {{ 'projectForm.releases.dialog.fehler.' + fehler | translate }}
      </p>
    }

    <div class="release-dialog__fuss">
      <button
        mat-stroked-button
        type="button"
        class="release-dialog__knopf"
        data-testid="release-abbrechen"
        [disabled]="speichert()"
        (click)="abbrechen()"
      >
        {{ 'projectForm.releases.dialog.abbrechen' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="release-dialog__knopf release-dialog__knopf--primaer"
        data-testid="release-speichern"
        [disabled]="speichernGesperrt()"
        (click)="speichern()"
      >
        {{
          (istBearbeiten() ? 'projectForm.releases.dialog.speichern' : 'projectForm.releases.dialog.anlegen')
            | translate
        }}
      </button>
    </div>
  </div>
</ng-template>
